module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUVJREFUOE+Vkz8rhlEYxn9XSZKSDFJKWWzKgk2UwScQg49gYDDIIO9g9E4+gEXKamOQAYNksAirP6+8YpNu3XWeOo4/z3Pu8Zzr+j33fZ/rkZm1AOvAInAJzEm6JrNkZjVgJfI9AkOSHnJYDmoA3YnpQtJwLugN6EhM5nBJL1Vh3tEJMJoYPoBeSc85oGVgIzHUJK1WhbjOO+oE7oG2yDgu6SgL5GIzWwDqkXFX0kw2KMBOgZFg/gT6JHmnlUqFysx6wojFUVNSVyWK7ygWmpm/nr9iUe/AgKSnMuA3UBhxGtiPjB6FWUl74d7DuwbsSDoudD9AQTwJHCRd3AKvwCDQHu7ugClJN7+CAmwCOCwbCWgCY3+CAsz/t/MKsPq/oGgn24Dv7q9aKgVF8ZgHNoE0Elelo6WfN7NWwBPvMekHzoAtSY0vAExpPYAzfWEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/tel-white.png
// module id = Es9Y
// module chunks = 0